import http from './utils'
import {getStore} from "../utils/storage";
//online
// export const webUrl = "http://www.人民互联网电视.com"; //主站域名
// export const webUrl = "http://47.94.152.222"; //主站域名
// export const webUrl = "http://人民互联网电视.com";

//test
// export const webUrl = "http://106.13.80.212";
// export const ApiUrl = "http://106.13.80.212";
// const baseUrl = ApiUrl+":828";

//Upload url:
export const uploadImgUrl = "http://upload.51haoshihui.cn/file/uploadImg?action=uploadimage&encode=utf-8";
// export const uploadImgUrl = "http://localhost:8282/file/uploadImg?action=uploadimage&encode=utf-8";
// http://192.168.1.101:828

//local
// export const webUrl = "http://localhost:8081";
// export const ApiUrl = "http://localhost";
// export const baseUrl = ApiUrl+":828";

//qqOnline
// export const webUrl = "http://localhost:8080";
export const webUrl = "http://www.人民互联网电视.com";
// export const ApiUrl = "http://49.235.63.241";
// export const baseUrl = ApiUrl+":8080";
export const ApiUrl = "http://api.rmzwds.com";
export const baseUrl = "http://api.rmzwds.com";
// export const baseUrl = "http://49.233.197.245:828";   //eolinker  临时api管理服务平台


// const baseUrl = webUrl+"/test_api"; //线上测试服务器
// const baseUrl = "http://106.13.80.212:828"; //测试服务器-master
// const baseUrl = "http://localhost:828"; //测试服务器-dev
// const baseUrl = "http://192.168.1.47:82"; //本地服务器

let userParams = () => {
  return {'token': getStore('token') || '', 'userId': getStore('user') ? JSON.parse(getStore('user')).id : ''}
};

/**
 * 网站导航
 * @param params null
 * @returns {*|Promise|Promise<any>}
 */
export const newsNav = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/column/list`, params)
};

/**
 * 网站导航下的子导航
 * @param params null
 * @returns {*|Promise|Promise<any>}
 */
export const newsNav2 = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/column/list2`, params)
};

/**
 * 首页资讯
 * @param params null
 * @returns {*|Promise|Promise<any>}
 */
export const indexNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/indexNews`, params)
};
export const indexNews2 = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/indexNews2`, params)
};

/**
 * 新闻列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const newsList = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/columnNews`, params)
};

/**
 * 新闻列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const columnHotNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/columnHotNews`, params)
};

/**
 * 读书新闻列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const dushuHotNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/book/dushuHotNews`, params)
};
/**
 * 阅读榜单列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const readRanking = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/book/readRanking`, params)
};
/**
 * 在线购书列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const buyBooksOnline = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/book/buyBooksOnline`, params)
};
/**
 * 众说列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const everyoneSay = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/book/everyoneSay`, params)
};
/**
 * 新书推荐列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const newBookRecommend = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/book/newBookRecommend`, params)
};
/**
 * 图书详情
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
export const bookDetail = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/book/bookDetail`, params)
};

/**
 * 视频栏目列表
 * @param params columnId 分类id
 * @returns {*|Promise|Promise<any>}
 */
// export const columnHotVideo = (params) => {
//   return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/columnHotVideo`, params)
// };
//   http://49.235.63.241:8080/PeopleNewsWeb/news/columnNews?columnId=5e563687e9a5136aeccd177c&page=1&limit=4
export const columnHotVideoNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/columnNews`, params)
};

/**
 * 搜索新闻
 * @param params key/page/limit
 * @returns {*|Promise|Promise<any>}
 */
export const newsSearch = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/search`, params)
};

/**
 * 资讯详情
 * @param params oid文章id
 * @returns {*|Promise|Promise<any>}
 */
export const newsInfo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/info`, params)
};

/**
 * 用户阅读记录
 * @param params token/userId/newsId
 * @returns {*|Promise|Promise<any>}
 */
export const historyAdd = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/history/add`, Object.assign(userParams(), params))
};

/**
 * 点赞/取消
 * @param params token/userId/newsId
 * @returns {*|Promise|Promise<any>}
 */
export const parseNet = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/history/parse`, Object.assign(userParams(), params))
};

/**
 * 收藏/取消
 * @param params token/userId/newsId
 * @returns {*|Promise|Promise<any>}
 */
export const collectNet = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/history/collect`, Object.assign(userParams(), params))
};

/**
 * 不感兴趣/取消
 * @param params token/userId/newsId
 * @returns {*|Promise|Promise<any>}
 */
export const interestNet = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/history/interest`, Object.assign(userParams(), params))
};

/**
 * 评论
 * @param params newsId/content
 * @returns {*|Promise|Promise<any>}
 */
export const commentAdd = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/comment/add`, Object.assign(userParams(), params))
};

/**
 * 评论列表
 * @param params newsId
 * @returns {*|Promise|Promise<any>}
 */
export const commentNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/comment/news`, Object.assign(userParams(), params))
};

/**
 * 评论点赞
 * @param params newsId/commentId
 * @returns {*|Promise|Promise<any>}
 */
export const commentPraise = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/comment/praise`, Object.assign(userParams(), params))
};

/**
 * 推荐阅读
 * @param params columnId/newsId
 * @returns {*|Promise|Promise<any>}
 */
export const suggestsNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/suggests`, params)
};

/**
 * 手机号密码登录
 * @param params phone/passwd
 * @returns {*|Promise|Promise<any>}
 */
export const userLogin = (params) => {
  return http.fetchPost(`${baseUrl}/PeopleNewsWeb/user/loginpw`, params)
};

/**
 * 手机号验证码登录
 * @param params phone/code
 * @returns {*|Promise|Promise<any>}
 */
export const userLoginPhone = (params) => {
  return http.fetchPost(`${baseUrl}/PeopleNewsWeb/user/login`, params)
};

/**
 * 用户详情
 * @param params uid
 * @returns {*|Promise|Promise<any>}
 */
export const userInfo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/info`, userParams())
};

/**
 * 验证码
 * @param params phone
 * @returns {*|Promise|Promise<any>}
 */
export const sendPhone = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/sendPhone`, params)
};

/**
 * 我的发布列表
 * @param params page/limit
 * @returns {*|Promise|Promise<any>}
 */
export const newsMy = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/my`, Object.assign(userParams(), params))
};

/**
 * 删除我的发布
 * @param params newsId
 * @returns {*|Promise|Promise<any>}
 */
export const delNewsMy = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/delete`, Object.assign(userParams(), params))
};

/**
 * 我的历史记录/我的收藏/我的赞
 * @param params null/collect/parse
 * @returns {*|Promise|Promise<any>}
 */
export const myInteractList = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/history/my`, Object.assign(userParams(), params))
};

/**
 * 我的系统消息
 * @param params page/limit
 * @returns {*|Promise|Promise<any>}
 */
export const messageMy = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/message/my`, Object.assign(userParams(), params))
};

/**
 * 我的评论
 * @param params page/limit
 * @returns {*|Promise|Promise<any>}
 */
export const commentMy = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/comment/my`, Object.assign(userParams(), params))
};

/**
 * 删除评论
 * @param params page/limit
 * @returns {*|Promise|Promise<any>}
 */
export const commentDel = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/comment/delete`, Object.assign(userParams(), params))
};

/**
 * 发布文章
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const newsAdd = (params) => {
  return http.fetchPost(`${baseUrl}/PeopleNewsWeb/news/add`, Object.assign(userParams(), params))
};

/**
 * 编辑文章
 */
export const newsEdit = (params) => {
  return http.fetchPost(`${baseUrl}/PeopleNewsWeb/news/edit`, Object.assign(userParams(), params))
};

/**
 * 媒体号列表
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const allMediaNo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/allMediaNo`,params)
};

/**
 * 媒体号新闻列表
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const mediaNoNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/mediaNoNews`,params)
};

/**
 * 我关注得媒体号
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const myMediaNo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/myMediaNo`,params)
};

/**
 * 我的粉丝列表
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const myFans = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/myFans`,params)
};

/**
 * 关注媒体号
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const subscribeMediaNo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/subscribeMediaNo`,params)
};

/**
 * 取消关注媒体号
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const unSubscribeMediaNo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/unSubscribeMediaNo`,params)
};

/**
 * 获取媒体号信息
 * @param params mediaNo
 * @returns {*|Promise|Promise<any>}
 */
export const getMediaNo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/getMediaNo`,params)
};


/**
 * 获取当前网络ip
 * @returns {string}
 */
export const getAddress = () => {
  let JSONP = document.createElement("script");
  JSONP.type = "text/javascript";
  JSONP.src = "http://pv.sohu.com/cityjson?ie=utf-8";
  document.getElementsByTagName("head")[0].appendChild(JSONP);
  return window.returnCitySN;
};

/**
 * 获取cip城市ip地址（config设置proxyTable跨域）
 * 搜狐api获取当前网络ip及城市  http://pv.sohu.com/cityjson?ie=utf-8
 */
// export const getCIp = () => {
//    return http.fetchPost(`apil/cityjson?ie=utf-8`,{})
// };

/**
 * 获取近三天的天气预报（根据cid,城市id地址获取 或 根据cip,城市ip地址获取）
 */
export const getWeatherByIp = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/api/getWeatherByIp`,params)
};

/**
 * 绑定新的第三方账号
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const bindNew = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/userPlatform/bindNew`, params)
};

/**
 * 认证媒体号
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const registerMediaNo = (type,params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/registerMediaNo?type=`+type, params)
};

/**
 * 获取用户认证媒体号信息
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const getMediaNoInfo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/getMediaNoInfo`, params)
};



/**
 * 上传文件
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
// 该上传图片的接口弃用
export const uploadFile = (formData) => {
  return http.uploadFile(`${baseUrl}/PeopleNewsWeb/file/uploadFile`, formData)
};

/**
 * 底部跳转链接页面: 不良信息举报,提交举报
**/
export const report = (params) => {
  // return http.fetchPost(`${baseUrl}/PeopleNewsWeb`, params)
};

/**
 * 获取亲子频道二级导航
 */
export const qzListColumn2 = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/parentChild/listColumn2`,params)
};

/**
 * 获取亲子频道,首页轮播图及右侧列表
 */
export const listPositionNews = (params) => {
  // ?position=main ,,?position=news3
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/parentChild/listPositionNews`,params)
};

/**
 * 多米诺骨牌，，上传视频作品
 */
export const dominoAddWorks = (params) => {
  return http.fetchPost(`${baseUrl}/PeopleNewsWeb/dmr/add`, Object.assign(userParams(), params))
};

/**
 * 多米诺骨牌，，全部作品列表
 */
export const dominoWorksList = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/dmr/list`,params)
};
/**
 * 多米诺骨牌，，投票
 */
export const dominoVote= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/dmr/vote`,params)
};
/**
 * 多米诺骨牌，，作品详情
 */
export const dominoWorksDetail= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/dmr/getNo`,params)
};
/**
 * 多米诺骨牌，，作品观看量
 */
export const dominoWorksWatch= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/dmr/watch`,params)
};
/**
 * 多米诺骨牌，，报名
 */
export const dominoRegister= (params) => {
  return http.fetchPost(`${baseUrl}/PeopleNewsWeb/dmr/register`, Object.assign(userParams(), params))
};
/**
 * 多米诺骨牌，，获取报名信息
 */
export const getDominoRegisterInfo= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/dmr/getRegisterInfo`,params)
};
/**
 * 多米诺骨牌，，精彩图片
 */
export const picTypeList= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/ad/picTypeList`,params)
};

/**
 * 人民学习，习近平专题
 */
export const chairman= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/chairman`,params)
};
/**
 * 人民学习，右侧图片新闻
 */
export const chairmanPics= (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/chairmanPics`,params)
};

/**
 * 老龄频道的子导航
 */
export const oldAgeNav2 = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/oldAge/listColumn2`, params)
};

/**
 * 老龄频道,查询子栏目关联的资讯列表
 */
export const oldAgeNewsList = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/oldAge/list`, params)
};

/**
 * 老龄频道,查询子栏目各个版块位置文章
 */
export const oldAgeColumn2HotNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/oldAge/column2HotNews`, params)
};

/**
 * 二级频道(子栏目)新闻列表页数据接口  ,,左侧列表
 */
export const secondColumnNews = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/columnNews2`, params)
};
/**
 * 二级频道(子栏目)新闻列表页数据接口  ,,右侧图文
 */
export const secondColumnNewsRight = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/news/columnNews2right`, params)
};

/**
 * 活动专题页,,老标会
 */
export const activityTopics = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/oldAgeTopic/index`, params)
};

/**
 * 活动专题页,,数字化时代老龄产业发展新趋势战略研讨会
 */
export const getDigitalAgingIndustrySeminar = (params) => {
  return http.fetchGet(`http://mlxcapi.rmzwds.cn/news/listIndexNewsQuery/meetingTitle`, params)
};


/**
 *  图片频道api
 */
// 图片频道首页
export const picIndex = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/index`, params)
};
// 认证摄影师
export const registerPhotographer = (type,params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/registerCameramanNo?type=`+type, params)
};
// 摄影师页面
export const photographers = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/map`, params)
};
// 获取摄影师信息
export const photographerInfo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/info`, params)
};
// 摄影师全部图片
export const photographerAllPic = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/allPic`, params)
};
// 摄影师图集
export const photographerPicGroup = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/list`, params)
};
// 图集分类
export const picGroupClassify = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/classifyList`, params)
};
// 创建图集
export const savePicGroup = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/save`, params)
};
// 删除图集
export const deletePicGroup = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/delete`, params)
};
// 图集保存上传图片
export const groupSavePic = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/saveImg`, params)
};
// 图集下的图片列表
export const groupAllPic = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/imgList`, params)
};
// 批量删除图片
export const batchDeleteImg = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/batchDeleteImg`, params)
};
// 探索页面
export const explore = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/explore`, params)
};
// 关注摄影师
export const focusCameraman = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/focus`, params)
};
// 取消关注摄影师
export const unFocusCameraman = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/unFocus`, params)
};
// 浏览摄影师
export const readCameraman = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/read`, params)
};
// 收藏图片
export const collectImg = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/collectImg`, params)
};
// 取消收藏图片
export const unCollectImg = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/unCollectImg`, params)
};
// 喜欢(赞) 图片
export const likeImg = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/likeImg`, params)
};
// 取消喜欢(赞) 图片
export const unLikeImg = (params) => {
  return http.fetchPostJSON(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/unLikeImg`, params)
};
// 专题、图片故事、时尚、旅游
export const pictureTopic = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/topic`, params)
};
// 图片新闻详情 ,同文章详情接口一样，返回参数部分不同

// 原创图库
export const originalPicGroup = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/original`, params)
};
// 图片购买 详情页
export const picBuyInfo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/picGroup/imgInfo`, params)
};
// 图片购买(授权)方案
export const authorizeProgramme = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/pic/authorize/index`, params)
};
// (方案)购买信息
export const programmeBuyInfo = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/pic/authorize/buyInfo`, params)
};
// 获取支付二维码链接
export const scanCode = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/wxPay/scanCode`, params)
};
// 获取支付状态
export const payStatus = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/wxPay/payStatus`, params)
};
//相似图片列表
export const similarImg = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/similarImg`, params)
};
// 用户收藏的图片列表
export const collectAllPic = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/user/cameraman/collectAllPic`, params)
};
// 获取用户授权列表
export const getUserAuthorizeList = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/pic/authorize/getUserAuthorizeList`, params)
};
//图片授权
export const authorizeImg = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/pic/authorize/authorizeImg`, params)
};
// 图片搜索
export const picSearch = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/search`, params)
};
// 图片搜索版块的标语、关键词、背景图
export const searchStyle = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/searchStyle`, params)
};
// 图片搜索结果页：搜索标签
export const searchTag = (params) => {
  return http.fetchGet(`${baseUrl}/PeopleNewsWeb/picChannel/searchTag`, params)
};



// WEBPACK FOOTER //
// ./src/api/index.js